import React from 'react';
import VerticalCenter from '../../../elements/VerticalCenter';
import liveVotingCommonScreen from '../common/LiveVotingScreenHOC';
import LeftTabbedGrayHeader from '../../../elements/headers/LeftTabbedGrayHeader';

class VotingStopped extends React.Component {
    render() {
        let {event, question, i18n} = this.props;

        return (
            <div
                className="fill-container"
                style={{
                    backgroundImage: 'url(' + this.props.resPath + 'img/live_vote_horses.png)',
                    backgroundSize: 'cover',
                }}>
                <LeftTabbedGrayHeader
                    color="none"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: 'auto',
                    }}>
                    {question.text}
                </LeftTabbedGrayHeader>
                <VerticalCenter>
                    <div className="content text-center well">
                        <h2>{i18n['livevoting.title-vote-close']}</h2>
                        <hr />
                        <h3>{i18n['livevoting.desc-vote-close']}</h3>
                    </div>
                </VerticalCenter>
            </div>
        );
    }
}

export default liveVotingCommonScreen(VotingStopped);
